import * as React from "react";
const SvgFiRrFileZipper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M9.949 16.481A1.18 1.18 0 0 1 8.819 18H6.99a1.18 1.18 0 0 1-1.13-1.519l.757-2.524a1.343 1.343 0 0 1 2.574 0zM22 10.485V19c0 2.757-2.243 5-5 5H7c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h4.515c1.869 0 3.627.728 4.95 2.05l3.484 3.486A6.95 6.95 0 0 1 22 10.486zm-6.949-7.021A5 5 0 0 0 14 2.659V7c0 .551.448 1 1 1h4.341a5 5 0 0 0-.805-1.05zM20 10.485q0-.245-.023-.485H15c-1.654 0-3-1.346-3-3V2.023A5 5 0 0 0 11.515 2H9v1a1 1 0 1 1-2 0V2C5.346 2 4 3.346 4 5v14c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3zM8 8a1 1 0 0 0 1-1V6a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m0 4a1 1 0 0 0 1-1v-1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1"
    />
  </svg>
);
export default SvgFiRrFileZipper;
